import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { PrecioCombustibleService } from '../../../services/PrecioCombustibleService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'combustible_precio_valor',
    label: 'Precio ($/L)',
    type: 'number',
    col: 12,
    placeholder: 'Ej. 24.50',
    validators: [
      Validators.required("El precio es obligatorio"),
      Validators.number("Debe ser un número válido")
    ],
  },
];

export const PrecioCombustibleForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await PrecioCombustibleService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await PrecioCombustibleService.guardar(values);
  };

  return (
    <CatalogForm
      title="Actualización de Precio de Combustible"
      subtitle="Tarifa actual del combustible por litro"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/PreciosCombustibles"
    />
  );
};

export default PrecioCombustibleForm;
